import React, { useState, useEffect } from "react";
import "./FilterSidebar.css";
import "../Pages/Cart.css";
import cartImg from "../assets/images/cartImg.png";
import { Link } from "react-router-dom";
import axios from "../api/axios";

export default function CartSidebar({ cartOpen, setCartOpen }) {
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;
  const userId = user ? user.id : null;

  const [cartItems, setCartItems] = useState([]);
  const [cartSummary, setCartSummary] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCartData = async () => {
    if (!userId) return;
    try {
      setLoading(true);
      const cartRes = await axios.post("/carts", { user_id: userId });
      let items = [];
      if (cartRes.data && cartRes.data.data) {
        cartRes.data.data.forEach((shop) => {
          if (shop.cart_items) {
            items = [...items, ...shop.cart_items];
          }
        });
      }
      setCartItems(items);

      const summaryRes = await axios.post("/cart-summary", { user_id: userId });
      setCartSummary(summaryRes.data);
      setLoading(false);
    } catch (err) {
      console.error("Error loading sidebar cart:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cartOpen) {
      fetchCartData();
    }
  }, [cartOpen]);

  useEffect(() => {
    window.addEventListener("cart-updated", fetchCartData);
    return () => {
      window.removeEventListener("cart-updated", fetchCartData);
    };
  }, []);

  const handleUpdateQty = async (cartItemId, newQty, upperLimit) => {
    if (newQty < 1) return;
    if (newQty > upperLimit) {
      alert(`Only ${upperLimit} items in stock.`);
      return;
    }

    try {
      const res = await axios.post("/carts/change-quantity", {
        id: cartItemId,
        quantity: newQty,
      });

      if (res.data.result) {
        await fetchCartData();
        window.dispatchEvent(new Event("cart-updated"));
      }
    } catch (err) {
      console.error("Error updating qty in sidebar:", err);
    }
  };

  const handleRemoveItem = async (cartItemId) => {
    try {
      const res = await axios.delete(`/carts/${cartItemId}`);
      if (res.data.result) {
        await fetchCartData();
        window.dispatchEvent(new Event("cart-updated"));
      }
    } catch (err) {
      console.error("Error removing item in sidebar:", err);
    }
  };

  return (
    <>
      <div className={`base ${cartOpen ? "active" : ""}`}>
        <div className="sidebar_filter_main">
          <div className="sidebar_filter_header">
            <h1>Cart</h1>
            <button className="close_btn" onClick={() => setCartOpen(false)}>
              ✕
            </button>
          </div>
          <div className="filter_cart">
            {loading && cartItems.length === 0 ? (
              <div className="text-center py-4">
                <span className="spinner-border spinner-border-sm text-dark"></span>
              </div>
            ) : cartItems.length === 0 ? (
              <div className="text-center py-5 text-muted">
                <p>Your cart is empty.</p>
                <Link to="/products" className="btn btn-dark btn-sm mt-2" onClick={() => setCartOpen(false)}>
                  Shop Now
                </Link>
              </div>
            ) : (
              <>
                <div className="cart-items-container" style={{ maxHeight: "calc(100vh - 250px)", overflowY: "auto" }}>
                  {cartItems.map((item) => (
                    <div className="cart-item" key={item.id}>
                      <img src={item.product_thumbnail_image || cartImg} alt="" className="img-fluid" />

                      <div className="cart-details">
                        <div className="cart-name fw-bold">{item.product_name}</div>
                        <div className="cart-meta text-muted small">
                          {item.variation && <span>Var: {item.variation}</span>}
                        </div>
                        <div className="cart-price fw-bold mt-1">{item.price}</div>

                        <div className="mt-2 d-flex align-items-center justify-content-between">
                          <div className="qty-box border rounded d-flex align-items-center">
                            <button onClick={() => handleUpdateQty(item.id, item.quantity - 1, item.upper_limit)}>-</button>
                            <p className="number mb-0 px-2">{item.quantity}</p>
                            <button onClick={() => handleUpdateQty(item.id, item.quantity + 1, item.upper_limit)}>+</button>
                          </div>
                          <button className="btn btn-sm text-danger remove-btn fs-5 p-0" onClick={() => handleRemoveItem(item.id)}>
                            ×
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="cart_total_box mt-auto pt-3 border-top">
                  <p className="text-muted small mb-2 text-center">Taxes & Shipping calculated at checkout</p>
                  <div className="cart_total_price d-flex justify-content-between fw-bold mb-3 fs-5">
                    <p className="mb-0">Total</p>
                    <p className="mb-0">{cartSummary?.grand_total || "₹0"}</p>
                  </div>
                  <div className="cart_buttons d-flex gap-2">
                    <button className="view_Cart btn btn-outline-dark w-50 py-2" onClick={() => setCartOpen(false)}>
                      <Link to="/cart" style={{ textDecoration: "none", color: "inherit" }}>
                        View Cart
                      </Link>
                    </button>
                    <button className="checkout_btnn btn btn-dark w-50 py-2" onClick={() => setCartOpen(false)}>
                      <Link to="/checkout" style={{ textDecoration: "none", color: "inherit" }}>
                        Checkout
                      </Link>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
